'use client';

import { Dialog } from '@/shared/components/ui/dialog';
import * as React from 'react';
import { useLookupCreateShop } from '../api/lookup-create-shop';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';
import { ShareButton } from '@/shared/components/ui/buttons/share-button';
import { CopyButton } from '@/shared/components/ui/buttons/copy-button';
import QRCode from 'react-qr-code';
import { Button, ButtonProps } from '@/shared/components/ui/button';
import { QrCodeIcon, User, ExternalLink } from 'lucide-react';

type LookupCreateShopProps = {
  saleId: string;
} & ButtonProps;

export function LookupCreateShop({ saleId, children, ...rest }: LookupCreateShopProps) {
  const [open, setOpen] = React.useState(false);
  const [showQR, setShowQr] = React.useState(false);
  const mutation = useLookupCreateShop({ mutationConfig: { onSuccess: () => setOpen(true) } });

  const link = mutation.data?.link ?? '';
  const title = "Sälj med personlig webshop";

  return (
    <Dialog
      title={title}
      trigger={
        <LoadingButton
          {...rest}
          onClick={() => mutation.mutate({ data: { saleId } })}
          isLoading={mutation.isPending}
        >
          {children}
        </LoadingButton>
      }
      description={title}
      onOpenChange={setOpen}
      open={open}
    >
      {!showQR ? (
        <div className="grid grid-cols-2 gap-4">
          <Button onClick={() => window.open(link, "_blank")} variant={'outline'} className="flex justify-start items-start flex-col h-auto py-4">
            <ExternalLink className="size-6" />
            Öppna direkt
          </Button>
          <ShareButton data={{ url: link }} variant={'outline'} className="flex justify-start items-start flex-col h-auto py-4 [&_[data-slot=icon]]:!size-6 gap-4">
            Dela länk
          </ShareButton>
          <CopyButton value={link} variant={'outline'} className="flex justify-start items-start flex-col h-auto py-4 [&_[data-slot=icon]]:!size-6 gap-4">
            Kopiera länk
          </CopyButton>
          <Button variant={'outline'} onClick={() => setShowQr(true)} className="flex justify-start items-start flex-col h-auto py-4">
            <QrCodeIcon className="size-6" />
            Visa QR-kod
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-center">Låt kunder skanna koden för att öppna webshop.</p>
          <QRCode value={link} className="mx-auto" />
          <Button variant="ghost" onClick={() => setShowQr(false)} className="w-full">
            Tillbaka
          </Button>
        </div>
      )}
    </Dialog>
  );
}
